import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ipcorp-input-number',
    templateUrl: 'input.number.component.html',
    styleUrls: ['./input.number.component.scss']
})
export class InputNumberComponent {
    
    @Output() valorAlterado: EventEmitter<number> = new EventEmitter<number>();
    @Input() contador: number = 1;
    
    constructor() { }

    incrementarValor() {
        this.contador++;
        this.valorAlterado.emit(this.contador);
    }

    decrementarValor() {
        if (this.contador > 1) 
            this.contador--;
        else 
            this.contador = 1;
        
        this.valorAlterado.emit(this.contador);
    }

    onValorAlterado() {        
        this.valorAlterado.emit(this.contador);
    }

    onTeclaPressionada($event) {
        let tecla = $event.keyCode || $event.which;
        return tecla !== 43 && tecla !== 45;        
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/component/input-number/input.number.component.ts